import ApiService from './ApiService';

class OrderApi extends ApiService {
    constructor() {
        super('');
    }

    /**
     * Get order detail by order ID for end user
     * @param orderId Order ID
     */
    getOrderDetail(orderId: string | number) {
        return this.get(`order/${orderId}`);
    }

    /**
     * Get order history for end user with pagination and filters
     * @param params Query parameters: page, size, code, status, order_at_from, order_at_to
     */
    getOrderHistory(params?: {
        page?: number,
        size?: number,
        code?: string,
        status?: string,
        order_at_from?: string,
        order_at_to?: string
    }) {
        return this.get('orders', params);
    }

    /**
     * Export invoice PDF for order
     * @param orderId Order ID
     */
    exportInvoicePDF(orderId: string | number) {
        return this.get(`order/${orderId}/export/pdf`, undefined, { responseType: 'blob' });
    }

    /**
     * Get GMO payment URL for re-payment
     * @param orderId Order ID to re-pay
     */
    getRepaymentUrl(orderId: string | number) {
        return this.post('re-payments/url', { orderId });
    }
}

export const orderApi = new OrderApi();
export default OrderApi;
